/**
 * @purpose: mengelola upload template POD-SUCCESS dan hasil proses status 10 di halaman web.
 * @called_by: views/app_outbound/pod_success.html.
 * @deps: Upload, urlServices, toaster, modalService.
 * @public: controller AngularJS podSuccessCtrl.
 * @side_effects: upload file Excel ke API, menampilkan modal konfirmasi, dan mengubah state hasil upload pada halaman.
 */
app.controller('podSuccessCtrl', function ($scope, Upload, urlServices, toaster, modalService) {
    var token = urlServices.ambilToken();

    $scope.uploadFile = null;
    $scope.uploading = false;
    $scope.uploadResult = null;
    $scope.templateUrl = '/api/pod-success/template' + (token ? ('?t=' + encodeURIComponent(token)) : '');

    function normalizeApiError(response) {
        if (!response) {
            return 'Error tidak terdeteksi';
        }
        if (response.data && response.data.err) {
            return response.data.err;
        }
        if (response.data && typeof response.data === 'string') {
            return response.data;
        }
        return response.statusText || 'Error tidak terdeteksi';
    }

    function getUploadHeaders() {
        token = urlServices.ambilToken();
        return token ? {
            'my-token': token
        } : {};
    }

    function normalizeApiBody(response) {
        return response && response.data ? response.data : null;
    }

    function showConfirm(modalOptions, onConfirm, onCancel) {
        modalService.showModal({}, angular.extend({
            closeButtonText: 'Batal',
            actionButtonText: 'Ya'
        }, modalOptions || {})).then(function (confirmed) {
            if (confirmed && onConfirm) {
                onConfirm();
            }
        }, function () {
            if (onCancel) {
                onCancel();
            }
        });
    }

    function buildStatus10WarningBody(precheckResult) {
        var awbs = (precheckResult && precheckResult.status10Awbs ? precheckResult.status10Awbs : []).slice(0, 5);
        var count = Number(precheckResult && precheckResult.status10Count || 0);
        var bodyText = 'Ada ' + count + ' AWB yang statusnya sudah 10.';

        if (awbs.length) {
            bodyText += ' nomor AWB: ' + awbs.join(', ');
            if (count > awbs.length) {
                bodyText += ', ...';
            }
            bodyText += '.';
        }

        return bodyText + ' Lanjutkan upload data ini?';
    }

    function executeUpload(allowExistingStatus10) {
        $scope.uploadResult = null;

        Upload.upload({
            url: '/api/pod-success/upload',
            withCredentials: true,
            headers: getUploadHeaders(),
            data: {
                file: $scope.uploadFile,
                allowExistingStatus10: allowExistingStatus10 ? '1' : '0'
            }
        }).then(function (response) {
            var body = normalizeApiBody(response);

            $scope.uploading = false;

            if (!(response && response.status === 200 && body && body.valid)) {
                return toaster.pop('error', 'POD Success', normalizeApiError(response));
            }

            $scope.uploadResult = body.dt || null;
            toaster.pop('success', 'POD Success', (($scope.uploadResult && $scope.uploadResult.successCount) || 0) + ' AWB berhasil diproses');
        }, function (response) {
            $scope.uploading = false;
            toaster.pop('error', 'POD Success', normalizeApiError(response));
        });
    }

    function runPrecheck() {
        $scope.uploading = true;

        Upload.upload({
            url: '/api/pod-success/precheck',
            withCredentials: true,
            headers: getUploadHeaders(),
            data: {
                file: $scope.uploadFile
            }
        }).then(function (response) {
            var body = normalizeApiBody(response);
            var precheckResult;

            if (!(response && response.status === 200 && body && body.valid)) {
                $scope.uploading = false;
                return toaster.pop('error', 'POD Success', normalizeApiError(response));
            }

            precheckResult = body.dt || {};
            if (Number(precheckResult.status10Count || 0) > 0) {
                return showConfirm({
                    closeButtonText: 'Batal',
                    actionButtonText: 'Lanjutkan',
                    headerText: 'Peringatan Status 10',
                    bodyText: buildStatus10WarningBody(precheckResult)
                }, function () {
                    executeUpload(true);
                }, function () {
                    $scope.uploading = false;
                });
            }

            return executeUpload(false);
        }, function (response) {
            $scope.uploading = false;
            toaster.pop('error', 'POD Success', normalizeApiError(response));
        });
    }

    $scope.resetResult = function () {
        $scope.uploadFile = null;
        $scope.uploadResult = null;
    };

    $scope.submitUpload = function () {
        if (!$scope.uploadFile) {
            return toaster.pop('warning', 'POD Success', 'Pilih file Excel terlebih dahulu');
        }

        showConfirm({
            headerText: 'Konfirmasi Upload POD-SUCCESS',
            bodyText: 'Apakah yakin untuk upload data ini?'
        }, function () {
            runPrecheck();
        });
    };
});